import { Level1MenuItem } from "@/features";
import { MdAttachMoney } from "react-icons/md";
import React, { ReactElement, useContext } from "react";
import { useTextDomainContext } from "@/app/providers";
import { permissionsBudget } from "@/utils";
import { RootState, useAppSelector } from "@/app/store";

const parentPath = "budget";

export const BudgetMenu = (): ReactElement => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const hasCompanies = useAppSelector(
    (state: RootState) => state?.auth?.user?.hasCompanies,
  );

  return (
    <Level1MenuItem
      link={`/${parentPath}`}
      label={gettext("Budget")}
      icon={<MdAttachMoney size={18} className="mx-3" />}
      codes={permissionsBudget}
      feature="common"
      hide={!hasCompanies}
    />
  );
};
